<template>
    <transition name="fade" @after-enter="showModalDialog = true">
        <div v-show="getLoginModalShow" class="ca-modal modal" :class="{'is-visible': getLoginModalShow}" tabindex="-1" role="dialog" aria-labelledby="loginModalLabel" :aria-hidden="!getLoginModalShow">
            <transition name="slideDown">
                <div v-show="showModalDialog" class="modal-dialog">
                    <div class="modal-content dark">
                        <div class="modal-header">
                            <h4 class="modal-title" id="loginModalLabel">Login</h4>
                            <button type="button" class="close" :aria-hidden="!getLoginModalShow" @click="doDismiss"><i class="fa fa-times"></i></button>
                        </div>
                        <div class="modal-body">

                            <div class="logo text-center">
                                <img class="img-responsive" srcset="/images/ca/ca-logo-2021-640x256.png 2x" src="/images/ca/ca-logo-2021-320x128.png" width="320" height="128" alt="Community Analytics">
                            </div>

                            <div v-if="hasErrors" class="alert alert-danger" role="alert">
                                <template v-for="(error, field, index) in errors">
                                    <ul class="list-unstyled" :key="index">
                                        <li v-for="(msg, index) in error" :key="index">{{ msg }}</li>
                                    </ul>
                                </template>
                            </div>

                            <form @submit.prevent="doLogin" novalidate>

                                <div class="form-group">
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fas fa-user-circle"></i></span>
                                        <input v-model="email" type="email" class="form-control input-lg" placeholder="Email">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fas fa-key"></i></span>
                                        <input v-model="password" type="password" class="form-control input-lg" placeholder="Password">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="checkbox-inline">
                                        <input v-model="remember" type="checkbox">
                                        <span>Remember me</span>
                                    </label>
                                </div>

                                <p class="small text-muted text-justify"><strong>Terms of use:</strong> The information contained within is the sole property of subscription holder and is commercial in confidence. By checking this box and signing in you are acknowledging that you are an authorised Government or Company representative. No other parties are entitled to proceed past this point and all traffic is monitored.</p>

                                <div class="form-group text-right m-t-20">
                                    <button class="btn btn-primary btn-block btn-lg" type="submit">Log in</button>
                                </div>

                            </form>

                        </div>
                        <div class="modal-footer">
                            <div class="text-center form-group">
                                <a :href="route('password.request')" class="text-muted"><i class="fa fa-lock m-r-5"></i> Forgot your password?</a>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
/* globals ca */
import { mapGetters, mapMutations, mapActions } from 'vuex';
import authClient from '@/api/authClient';

export default {
    name: 'LoginModal',
    data() {
        return {
            errors: {},
            showModalDialog: false
        }
    },
    computed: {
        ...mapGetters([
            'getLoginModalShow',
            'getLoginModalCredentials',
            'getLoginModalEmail',
            'getLoginModalPassword',
            'getLoginModalRemember',
            'getLoginModalCallback'
        ]),
        email: {
            get () {
                return this.getLoginModalEmail;
            },
            set (value) {
                this.setLoginModalEmail(value);
            }
        },
        password: {
            get () {
                return this.getLoginModalPassword;
            },
            set (value) {
                this.setLoginModalPassword(value);
            }
        },
        remember: {
            get () {
                return this.getLoginModalRemember;
            },
            set (value) {
                this.setLoginModalRemember(value);
            }
        },
        visible() {
            return this.getLoginModalShow;
        },
        hasErrors() {
            return Object.keys(this.errors).length > 0;
        }
    },
    methods: {
        ...mapActions([
            'closeLoginModal'
        ]),
        ...mapMutations([
            'setLoginModalEmail',
            'setLoginModalPassword',
            'setLoginModalRemember',
            'setApiToken'
        ]),
        doLogin() { // uses passes callback so form is valid
            const that = this;

            // LOGIN
            authClient.login(this.getLoginModalCredentials).then((response) => {
                if (response.status === 200) {
                    const token = response.data.access_token;
                    // Override current api token
                    // TODO: what else needs to be set?
                    ca.user.token = token;
                    this.setApiToken(token)

                    // Callback (if defined, close the modal)
                    this.getLoginModalCallback();
                    this.doDismiss();
                }
            }).catch((error) => {
                if (error.response.status === 422) { // We have errors
                    that.errors = error.response.data.errors;
                }
            });
        },
        doDismiss() {
            this.showModalDialog = false;
            this.closeLoginModal();
        },
    },
    mounted() {
        if (this.getLoginModalShow) {
            this.showModalDialog = true;
        }
    }
}
</script>

<style lang="scss" scoped>

.modal {

    .logo {
        margin-bottom: 2.5rem;

        img {
            margin: 0 auto;
            max-width: 300px;
        }
    }

    .form-group { // override ca.scss
        border-top: none;
        margin-top: 0;
        padding-top: 0;
        margin-bottom: 1.5rem;
    }

    .input-lg {
        height: 46px;
    }

    .input-group-addon {
        background: rgb(232, 240, 254);
        i {
            font-size: 16px;
        }
    }

    .checkbox-inline span {
        display: inline-block;
        vertical-align: middle;
    }
}


.fade {
    backface-visibility: hidden;
    z-index: 1;
}


/* appearing */
.fade-enter-active {
    transition: all 400ms ease-out;
}

/* disappearing */
.fade-leave-active {
    transition: all 200ms ease-in;
    position: absolute;
    z-index: 0;
}

/* appear at / disappear to */
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.slide-enter-active {
    transition: max-height .5s;
}

.slide-enter, .slide-leave-to, .slide-leave{
    max-height: 0;
}
</style>
